/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Cooked_OnInputs */

const en_history_cooked_on = /** @type {(inputs: History_Cooked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooked on`)
};

const de_history_cooked_on = /** @type {(inputs: History_Cooked_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekocht am`)
};

/**
* | output |
* | --- |
* | "Cooked on" |
*
* @param {History_Cooked_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_cooked_on = /** @type {((inputs?: History_Cooked_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Cooked_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_cooked_on(inputs)
	return en_history_cooked_on(inputs)
});